import { Link as RouterLink } from 'react-router-dom';
// @mui
import { styled, alpha } from '@mui/material/styles';
import { Box, Link, Typography } from '@mui/material';
// auth
import { useAuthContext } from '../../../context/useAuthContext';
// routes
import { PATH_MY_ACCOUNT } from '../../../routes/paths';
// components
import { CustomAvatar } from '../../../components/custom-avatar';
// Model
import { BuyerTypeDescription } from '../../../model/dashboard/user/myAccountModel';

// ----------------------------------------------------------------------

const StyledRoot = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(2, 2.5),
  borderRadius: Number(theme.shape.borderRadius) * 1.5,
  backgroundColor: alpha(theme.palette.grey[500], 0.12),
}));

// ----------------------------------------------------------------------

export default function NavAccount() {
  const { user } = useAuthContext();

  return (
    <Link to={PATH_MY_ACCOUNT.account} component={RouterLink} underline="none" color="inherit">
      <StyledRoot>
        <CustomAvatar src={user?.photoURL} alt={user?.first_name} name={user?.first_name} />

        <Box sx={{ ml: 2, minWidth: 0 }}>
          <Typography variant="subtitle2" noWrap>
            {`${user?.first_name} ${user?.last_name}`}
          </Typography>

          <Typography variant="body2" noWrap sx={{ color: 'text.secondary' }}>
            Tipo: {BuyerTypeDescription(user?.buyer_type)}
          </Typography>
        </Box>
      </StyledRoot>
    </Link>
  );
}
